import React, { useEffect, useState } from "react";
import { theme } from "../theme.js";
import LoadingOverlay from "../components/LoadingOverlay.jsx";
import { API_URL } from "../utils/constants.js";

export default function Confidential() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

useEffect(() => {
    fetch(`${API_URL}/api/legal`)
    .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
    })
    .then((data) => {
        setDocs(data || []);
        setLoading(false);
    })
    .catch((err) => {
        console.error("API error:", err);
        setError(err.message || "Error fetching legal documents");
        setLoading(false);
    });
}, []);

  if (loading) return <LoadingOverlay text="Chargement..." />;
  if (error) return <div style={{ color: theme.colors.error }}>{error}</div>;

  return (
    <div style={{ padding: 32 }}>
      <h2 style={{ color: theme.colors.dark, fontSize: theme.fonts.size.xl, marginBottom: theme.spacing.lg }}>
        Documents légaux
      </h2>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {docs.map(doc => (
          <li key={doc.id} style={{ marginBottom: theme.spacing.md }}>
            <a 
              href={doc.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: theme.colors.dark, 
                fontWeight: theme.fonts.weight.semibold, 
                fontSize: theme.fonts.size.md, 
                transition: `color ${theme.transitions.base}` 
              }}
              onMouseOver={e => e.currentTarget.style.color = theme.colors.light}
              onMouseOut={e => e.currentTarget.style.color = theme.colors.dark}
            >
              {doc.name}
            </a>
          </li>
        ))}
      </ul>
      {loading && <LoadingOverlay text="Chargement..." />}
    </div>
  );
}
